import { useResource } from '@thesisedu/feature-react'
import { orderBy } from 'lodash'

import { ExploreLookingForResource } from '../types'

export function useLookingForResources() {
  return orderBy(useResource<ExploreLookingForResource>('ExploreLookingFor'), 'weight', 'asc')
}
